import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

import {
  getDuplicatePeoplePage,
  getDuplicatePeoplePageCount
} from '../../store/selectors/duplicates';
import { retrievePeopleDuplicates } from 'bundles/contact/index/store/actions/duplicates';

export class DuplicatesPagination extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
    onPageChange: PropTypes.func
  };

  render() {
    const { currentPage, totalPages, onPageChange } = this.props;
    if (totalPages <= 1) return null;

    return (
      <div className="text-center">
        <UltimatePagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChange={onPageChange}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentPage: getDuplicatePeoplePage(state),
  totalPages: getDuplicatePeoplePageCount(state)
});

const mapDispatchToProps = {
  onPageChange: retrievePeopleDuplicates
};

export default connect(mapStateToProps, mapDispatchToProps)(DuplicatesPagination);
